<template>
  <BCard>
    <!-- Title & Back Button -->
    <div class="flex items-center gap-x-[.75rem] mb-[1.5rem]">
      <BButton
        variant="primary"
        size="sm"
        class="!bg-[#F95031] !border-[#F95031] flex items-center justify-center"
        @click="$router.push('/komads/bm-management')"
      >
        <img
          class="size-[18px]"
          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/arrow-left-2.svg"
          alt="arrow left"
        >
      </BButton>
      <h1 class="text-[#333333] text-[20px] font-semibold">
        Detail Business Manager{{ bmName ? ' - ' + bmName : '' }}
      </h1>
    </div>

    <!-- Analytic Cards Container -->
    <div class="mb-[1.5rem] border border-[#E2E2E2] rounded-lg p-[1.5rem] bg-white">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-[1rem]">
        <!-- 1. Estimasi Penggunaan Saldo -->
        <div class="bm-analytic-card col-span-2">
          <div class="flex items-center gap-x-[.5rem]">
            <div class="bm-analytic-card-icon-container size-[24px] bg-[#DFF3FF]">
              <span class="k-moneys !text-[#08A0F7]" />
            </div>
            <h2 class="text-[#626262] text-[14px]">
              Estimasi Penggunaan Saldo
            </h2>
            <span
              id="tooltip-estimasi-saldo-detail"
              class="cursor-pointer flex items-center"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="8"
                  cy="8"
                  r="7"
                  stroke="#08A0F7"
                  stroke-width="1.5"
                />
                <path
                  d="M8 7.5V11.5"
                  stroke="#08A0F7"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <circle
                  cx="8"
                  cy="5"
                  r="1"
                  fill="#08A0F7"
                />
              </svg>
            </span>
            <b-tooltip
              target="tooltip-estimasi-saldo-detail"
              triggers="hover"
              placement="topRight"
              variant="primary"
              custom-class="long-text-tooltip"
            >
              Dihitung berdasarkan akumulasi Estimasi Penggunaan Saldo dari pembaruan terakhir pada setiap Business Manager
            </b-tooltip>
          </div>
          <p class="text-[#333333] text-[24px] md:text-[28px] font-bold">
            {{ IDR(analyticSection.estimated_balance_bm || 0) }}
          </p>
        </div>

        <!-- 2. Total Spending -->
        <div class="bm-analytic-card col-span-2">
          <div>
            <div class="flex items-center gap-x-[.5rem] mb-[16px]">
              <div class="bm-analytic-card-icon-container size-[24px] bg-[#EFEFEF]">
                <span class="k-money-send !text-[#828282]" />
              </div>
              <h2 class="text-[#626262] text-[14px]">
                Total Spending
              </h2>
              <span
                id="tooltip-total-spending-detail"
                class="cursor-pointer flex items-center"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="8"
                    cy="8"
                    r="7"
                    stroke="#08A0F7"
                    stroke-width="1.5"
                  />
                  <path
                    d="M8 7.5V11.5"
                    stroke="#08A0F7"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <circle
                    cx="8"
                    cy="5"
                    r="1"
                    fill="#08A0F7"
                  />
                </svg>
              </span>
              <b-tooltip
                target="tooltip-total-spending-detail"
                triggers="hover"
                placement="topLeft"
                variant="primary"
                custom-class="long-text-tooltip"
              >
                Akumulasi nominal spending yang telah digunakan oleh seluruh akun selama penggunaan Business Manager
              </b-tooltip>
              <VSelect
                v-model="datePeriod"
                :options="datePeriodOptions"
                :clearable="false"
                :searchable="false"
                label="text"
                class="!w-[160px] ms-auto"
                @option:selected="getBusinessManagerDetailStats"
              />
            </div>
            <BSpinner
              v-if="loadingStats"
              class="ml-1 !size-[20px]"
              variant="primary"
            />
            <p
              v-else
              class="text-[#333333] text-[24px] md:text-[28px] font-bold"
            >
              {{ IDR(analyticSection.total_spending || 0) }}
            </p>
          </div>
          <p class="text-[#828282] text-[12px] !mt-[1rem]">
            Akumulasi spending seluruh akun
          </p>
        </div>

        <!-- 3. Total Akun Terbuat -->
        <div class="bm-analytic-card">
          <div class="flex items-center gap-x-[.5rem]">
            <div class="bm-analytic-card-icon-container size-[24px] bg-[#DCF3EB]">
              <span class="k-profile-tick !text-[#34A770]" />
            </div>
            <h2 class="text-[#626262] text-[14px]">
              Total Akun Terbuat
            </h2>
            <span
              id="tooltip-total-akun-detail"
              class="cursor-pointer flex items-center"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="8"
                  cy="8"
                  r="7"
                  stroke="#08A0F7"
                  stroke-width="1.5"
                />
                <path
                  d="M8 7.5V11.5"
                  stroke="#08A0F7"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <circle
                  cx="8"
                  cy="5"
                  r="1"
                  fill="#08A0F7"
                />
              </svg>
            </span>
            <b-tooltip
              target="tooltip-total-akun-detail"
              triggers="hover"
              placement="topLeft"
              variant="primary"
              custom-class="long-text-tooltip"
            >
              Total akun yang berhasil dibuat pada Business Manager
            </b-tooltip>
          </div>
          <p class="text-[#333333] text-[24px] md:text-[28px] font-bold">
            {{ analyticSection.total_accounts || 0 }}
          </p>
        </div>

        <!-- 4. Meta Whitelist -->
        <div class="bm-analytic-card">
          <div class="flex items-center gap-x-[.5rem]">
            <div class="bm-analytic-card-icon-container size-[24px] bg-[#FEF2CD]">
              <span class="k-profile-2user !text-[#FBBC05]" />
            </div>
            <h2 class="text-[#626262] text-[14px]">
              Meta Whitelist
            </h2>
          </div>
          <p class="text-[#333333] text-[24px] md:text-[28px] font-bold">
            {{ analyticSection.total_whitelist || 0 }}
          </p>
        </div>

        <!-- 5. CPAS Whitelist -->
        <div class="bm-analytic-card">
          <div class="flex items-center gap-x-[.5rem]">
            <div class="bm-analytic-card-icon-container size-[24px] bg-[#FFEDED]">
              <span class="k-people !text-[#E31A1A]" />
            </div>
            <h2 class="text-[#626262] text-[14px]">
              CPAS Whitelist
            </h2>
          </div>
          <p class="text-[#333333] text-[24px] md:text-[28px] font-bold">
            {{ analyticSection.total_cpas || 0 }}
          </p>
        </div>

        <!-- 6. Status Akun -->
        <div class="bm-analytic-card">
          <div class="flex items-center gap-x-[.5rem]">
            <div class="bm-analytic-card-icon-container size-[24px] bg-[#DFF3FF]">
              <span class="k-profile-2user !text-[#08A0F7]" />
            </div>
            <h2 class="text-[#626262] text-[14px]">
              Status Akun
            </h2>
            <span
              id="tooltip-status-akun-detail"
              class="cursor-pointer flex items-center"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="8"
                  cy="8"
                  r="7"
                  stroke="#08A0F7"
                  stroke-width="1.5"
                />
                <path
                  d="M8 7.5V11.5"
                  stroke="#08A0F7"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <circle
                  cx="8"
                  cy="5"
                  r="1"
                  fill="#08A0F7"
                />
              </svg>
            </span>
            <b-tooltip
              target="tooltip-status-akun-detail"
              triggers="hover"
              placement="topLeft"
              variant="primary"
              custom-class="long-text-tooltip"
            >
              Jumlah akun yang dikelompokkan berdasarkan status saat ini, yaitu Active, Restricted, dan Invalid
            </b-tooltip>
          </div>
          <div class="ms-[2rem] space-y-[4px]">
            <div class="flex items-center text-[13px] text-[#626262]">
              <span class="w-[8px] h-[8px] rounded-full bg-[#34A853] mr-[8px]" />
              <span class="w-[80px]">Active</span>
              <span class="mr-[8px]">:</span>
              <span class="font-semibold text-[#333333]">{{ analyticSection.status_stats ? analyticSection.status_stats.total_active || 0 : 0 }}</span>
            </div>
            <div class="flex items-center text-[13px] text-[#626262]">
              <span class="w-[8px] h-[8px] rounded-full bg-[#E31A1A] mr-[8px]" />
              <span class="w-[80px]">Restricted</span>
              <span class="mr-[8px]">:</span>
              <span class="font-semibold text-[#333333]">{{ analyticSection.status_stats ? analyticSection.status_stats.total_restricted || 0 : 0 }}</span>
            </div>
            <div class="flex items-center text-[13px] text-[#626262]">
              <span class="w-[8px] h-[8px] rounded-full bg-[#828282] mr-[8px]" />
              <span class="w-[80px]">Invalid</span>
              <span class="mr-[8px]">:</span>
              <span class="font-semibold text-[#333333]">{{ analyticSection.status_stats ? analyticSection.status_stats.total_invalid || 0 : 0 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Table Section -->
    <div class="border border-[#E2E2E2] rounded-lg p-[1.5rem] bg-white">
      <!-- Toolbar -->
      <div class="flex flex-col md:flex-row justify-between md:items-center gap-y-[1rem] mb-[1.5rem]">
        <div>
          <h2 class="text-[#333333] text-[20px] font-semibold mb-0">
            Daftar Akun Whitelist
          </h2>
        </div>

        <div class="flex items-center gap-[12px] relative">
          <!-- Search Input -->
          <div class="flex items-center w-[280px] md:w-[320px] rounded-[8px] gap-[8px] px-[12px] border border-[#E2E2E2] h-[40px] bg-white">
            <span class="k-search-normal-1 text-[#828282] text-[18px]" />
            <BFormInput
              v-model="tempFilter.search"
              placeholder="Cari Nama Akun, Email, ID Ad Acc..."
              class="border-0 !p-0 shadow-none !text-[13px] grow"
              @input="onSearchInput"
            />
          </div>

          <!-- Filter Button -->
          <div class="flex items-center flex-row">
            <BButton
              id="filter"
              size="sm"
              variant="primary"
              class="position-relative"
              @click="showFilter = !showFilter"
            >
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
                alt="Komerce"
                width="20"
              >
              <span
                v-if="activeFilterCount > 0"
                class="bg-[#F95031] -top-4 badge position-absolute start-100 translate-middle rounded-pill"
              >
                <span class="text-white font-semibold">{{
                  activeFilterCount
                }}</span>
              </span>
            </BButton>
            <ul
              v-if="showFilter"
              ref="filterContainer"
              class="d-block position-absolute border bg-white right-0 top-[calc(100%_+_5px)] z-20 text-black font-medium text-[12px] rounded-xl"
            >
              <div class="text-black pl-2 py-1 text-[16px] border rounded-t-xl">
                Filter
              </div>
              <!-- Jenis Akun -->
              <div
                class="hover:bg-[#FCD4BE] relative"
                tabindex="-1"
                @focusin="isJenisAkunFocused = true"
                @focusout="event => {
                  if (!event.currentTarget.contains(event.relatedTarget)) {
                    isJenisAkunFocused = false
                  }
                }"
              >
                <div
                  class="btn d-flex w-100"
                  role="button"
                  tabindex="0"
                >
                  <span>Jenis Akun</span>
                  <div
                    v-if="tempFilter.type !== ''"
                    class="text-primary ml-[5px]"
                  >
                    (1)
                  </div>
                </div>
                <div
                  :class="isJenisAkunFocused ? 'block' : 'hidden'"
                  class="absolute right-[calc(100%_+_5px)] bottom-0 bg-white min-w-[240px] p-[1rem] border rounded-md shadow space-y-[1rem]"
                >
                  <div
                    v-for="(item, index) in typeOptions"
                    :key="index"
                  >
                    <b-form-radio
                      v-model="tempFilter.type"
                      :value="item.value"
                      class="custom-control-primary"
                      name="type-radio"
                    >
                      <span class="hover:cursor-pointer">
                        {{ item.text }}
                      </span>
                    </b-form-radio>
                  </div>
                </div>
              </div>
              <!-- Status Akun -->
              <div
                class="hover:bg-[#FCD4BE] relative"
                tabindex="-1"
                @focusin="isStatusAkunFocused = true"
                @focusout="event => {
                  if (!event.currentTarget.contains(event.relatedTarget)) {
                    isStatusAkunFocused = false
                  }
                }"
              >
                <div
                  class="btn d-flex w-100"
                  role="button"
                  tabindex="0"
                >
                  <span>Status Akun</span>
                  <div
                    v-if="filledSelectedStatuses.length > 0"
                    class="text-primary ml-[5px]"
                  >
                    ({{ filledSelectedStatuses.length }})
                  </div>
                </div>
                <div
                  :class="isStatusAkunFocused ? 'block' : 'hidden'"
                  class="absolute right-[calc(100%_+_5px)] bottom-0 bg-white min-w-[240px] p-[1rem] border rounded-md shadow space-y-[1rem]"
                >
                  <div
                    v-for="(item, index) in statusOptions"
                    :key="index"
                  >
                    <b-form-checkbox
                      :checked="isStatusChecked(item.value)"
                      class="custom-control-primary"
                      name="status-checkbox"
                      @change="toggleStatusOption(item.value)"
                    >
                      <span class="text-[#333333] hover:cursor-pointer">
                        {{ item.text }}
                      </span>
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
              <!-- Tanggal Pembuatan -->
              <div class="hover:bg-[#FCD4BE]">
                <date-range-picker
                  ref="picker"
                  v-model="tempFilter.dateRange"
                  :locale-data="locale"
                  :ranges="datePickerRanges"
                  :max-date="new Date()"
                  :opens="'left'"
                  class="w-100"
                  control-container-class="border-0"
                >
                  <template v-slot:input>
                    <div class="d-flex btn">
                      <span>Tanggal Pembuatan</span>
                      <div
                        v-if="tempFilter.dateRange.startDate && tempFilter.dateRange.endDate"
                        class="text-primary ml-[5px]"
                      >
                        (1)
                      </div>
                    </div>
                  </template>
                </date-range-picker>
              </div>
              <div class="border-t-2 p-[1rem] justify-between d-flex gap-[1rem]">
                <b-button
                  variant="outline-primary"
                  class="w-40 rounded-lg"
                  @click="resetFilter"
                >
                  Reset Filter
                </b-button>
                <b-button
                  type="submit"
                  variant="primary"
                  class="w-40 rounded-lg"
                  @click="applyFilter"
                >
                  Terapkan
                </b-button>
              </div>
            </ul>
          </div>
        </div>
      </div>

      <!-- List -->
      <PartnerAccountTable
        id="detail-bm-list-table"
        ref="partnerAccountTable"
        :items="items"
        :loading="loadingTable"
      />
    </div>
  </BCard>
</template>

<script>
import { IDR } from '@/libs/currency'
import { newAxiosIns } from '@/libs/axios'
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {
  today, last7, last30, firstDateOfMonth,
} from '@/store/helpers'
import { DATE_NUMBER_DASH_REVERSE } from '@/libs/filterDate'
import VSelect from 'vue-select'
import PartnerAccountTable from './Table.vue'
import '@core/scss/vue/libs/vue-select.scss'
import 'vue-select/dist/vue-select.css'

export default {
  components: {
    DateRangePicker,
    PartnerAccountTable,
    VSelect,
  },
  data() {
    return {
      observer: null,
      analyticSection: {},
      bmName: '',
      showFilter: false,
      isJenisAkunFocused: false,
      isStatusAkunFocused: false,
      filter: {
        search: '',
        type: '',
        status: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
      },
      tempFilter: {
        search: '',
        type: '',
        status: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
      },
      datePeriod: {},
      limit: 10,
      offset: 0,
      isLastData: false,
      typeOptions: [
        { value: '', text: 'Semua' },
        { value: 'whitelist', text: 'Meta Whitelist' },
        { value: 'cpas', text: 'CPAS Whitelist' },
      ],
      statusOptions: [
        { value: 'semua', text: 'Semua' },
        { value: 'active', text: 'Active' },
        { value: 'restricted', text: 'Restricted' },
        { value: 'invalid', text: 'Invalid' },
      ],
      datePickerRanges: {
        'Hari ini': [today, today],
        '7 Hari Terakhir': [last7, today],
        '30 Hari Terakhir': [last30, today],
        'Bulan Ini': [firstDateOfMonth, today],
      },
      datePeriodOptions: [
        { text: 'Semua', value: 'all' },
        { text: 'Bulan Ini', value: 'this_month' },
        { text: 'Bulan Lalu', value: 'last_month' },
      ],
      locale: {
        format: 'dd/mm/yyyy',
        applyLabel: 'Terapkan',
        cancelLabel: 'Batal',
      },
      items: [],
      loadingTable: false,
      loadingStats: false,
      IDR,
    }
  },
  computed: {
    activeFilterCount() {
      let count = 0
      if (this.filter.type) count += 1
      const activeStatuses = this.filter.status.filter(s => s !== 'semua')
      if (activeStatuses.length > 0) count += 1
      if (this.filter.dateRange && this.filter.dateRange.startDate && this.filter.dateRange.endDate) count += 1
      return count
    },
    filledSelectedStatuses() {
      return this.tempFilter.status.filter(s => s !== 'semua')
    },
    hasActiveFilter() {
      return this.activeFilterCount > 0
    },
  },
  mounted() {
    const [_, thisMonth] = this.datePeriodOptions
    this.datePeriod = thisMonth
    this.getBusinessManagerDetailStats()
    this.getBusinessManagerDetailList()
    this.setupIntersectionObserver()
  },
  beforeDestroy() {
    if (this.debouncedSearchHandler) {
      this.debouncedSearchHandler.cancel()
    }
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  created() {
    this.debouncedSearchHandler = _.debounce(() => {
      this.filter.search = this.tempFilter.search
      this.handleChangeFilter()
    }, 500)
  },
  methods: {
    onSearchInput() {
      this.debouncedSearchHandler()
    },
    toggleStatusOption(val) {
      if (val === 'semua') {
        const nonSemuaOptions = this.statusOptions.filter(o => o.value !== 'semua')
        const allSelected = nonSemuaOptions.every(o => this.tempFilter.status.includes(o.value))
        if (allSelected) {
          this.tempFilter.status = []
        } else {
          this.tempFilter.status = this.statusOptions.map(opt => opt.value)
        }
        return
      }

      const index = this.tempFilter.status.indexOf(val)
      if (index > -1) {
        this.tempFilter.status.splice(index, 1)
        const semuaIndex = this.tempFilter.status.indexOf('semua')
        if (semuaIndex > -1) {
          this.tempFilter.status.splice(semuaIndex, 1)
        }
      } else {
        this.tempFilter.status.push(val)
        const nonSemuaOptions = this.statusOptions.filter(o => o.value !== 'semua')
        const allSelected = nonSemuaOptions.every(o => this.tempFilter.status.includes(o.value))
        if (allSelected && !this.tempFilter.status.includes('semua')) {
          this.tempFilter.status.push('semua')
        }
      }
    },
    isStatusChecked(val) {
      if (val === 'semua') {
        const nonSemuaOptions = this.statusOptions.filter(o => o.value !== 'semua')
        return nonSemuaOptions.length > 0 && nonSemuaOptions.every(o => this.tempFilter.status.includes(o.value))
      }
      return this.tempFilter.status.includes(val)
    },
    formatSelectedDateRange(range) {
      if (!range || !range.startDate || !range.endDate) return 'Belum dipilih'
      const start = moment(range.startDate).format('DD/MM/YYYY')
      const end = moment(range.endDate).format('DD/MM/YYYY')
      return `${start} - ${end}`
    },
    clearDateRange() {
      this.tempFilter.dateRange = {
        startDate: null,
        endDate: null,
      }
    },
    resetFilter() {
      this.tempFilter = {
        search: '',
        type: '',
        status: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
      }
      this.filter = {
        search: '',
        type: '',
        status: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
      }
      this.showFilter = false
      this.handleChangeFilter()
    },
    applyFilter() {
      this.filter = {
        search: this.tempFilter.search,
        type: this.tempFilter.type,
        status: [...this.tempFilter.status],
        dateRange: {
          startDate: this.tempFilter.dateRange ? this.tempFilter.dateRange.startDate : null,
          endDate: this.tempFilter.dateRange ? this.tempFilter.dateRange.endDate : null,
        },
      }
      this.showFilter = false
      this.handleChangeFilter()
    },
    handleChangeFilter() {
      this.items = []
      this.offset = 0
      this.isLastData = false
      this.getBusinessManagerDetailList()
    },
    async getBusinessManagerDetailStats() {
      this.loadingStats = true
      const params = {
        period: this.datePeriod.value,
      }

      const url = `komads/api/v1/admin/system_bm/${this.$route.params.id}/stats`

      await newAxiosIns
        .get(url, { params })
        .then(res => {
          const resData = res && res.data ? res.data.data : null
          if (!resData) return

          this.bmName = resData.bm_name
          this.analyticSection = {
            total_spending: resData.total_spending,
            estimated_balance_bm: resData.estimated_balance_bm,
            total_accounts: resData.total_accounts,
            total_whitelist: resData.total_whitelist,
            total_cpas: resData.total_cpas,
            status_stats: resData.status_stats || {},
          }
        })
        .catch(() => {
          this.$toast_error({ title: 'Gagal', message: 'Gagal memuat data statistik' })
        })
        .finally(() => {
          this.loadingStats = false
        })
    },
    async getBusinessManagerDetailList() {
      this.loadingTable = true

      const params = {
        limit: this.limit,
        offset: this.offset,
      }

      if (this.filter.search) {
        params.search = this.filter.search
      }

      if (this.filter.type) {
        params.ad_account_type = this.filter.type
      }

      const activeStatuses = this.filter.status.filter(s => s !== 'semua')
      if (activeStatuses.length > 0) {
        params.account_status = activeStatuses.join(',')
      }

      if (this.filter.dateRange && this.filter.dateRange.startDate && this.filter.dateRange.endDate) {
        params.start_date = DATE_NUMBER_DASH_REVERSE(this.filter.dateRange.startDate)
        params.end_date = DATE_NUMBER_DASH_REVERSE(this.filter.dateRange.endDate)
      }

      const url = `komads/api/v1/admin/system_bm/${this.$route.params.id}/accounts`

      await newAxiosIns
        .get(url, { params })
        .then(res => {
          const resData = res && res.data ? res.data.data : null
          if (!resData) return

          const whitelistAccounts = resData || []

          if (whitelistAccounts.length < this.limit) {
            this.isLastData = true
          } else {
            this.isLastData = false
          }

          this.items.push(...whitelistAccounts)
          this.offset += whitelistAccounts.length
        })
        .catch(() => {
          this.items = []
        })
        .finally(() => {
          this.loadingTable = false
        })
    },
    setupIntersectionObserver() {
      const tableComponent = this.$refs.partnerAccountTable
      if (!tableComponent) return

      const sentinel = tableComponent.$refs?.scrollSentinel
      const root = tableComponent.$refs?.tableContainer
      if (!sentinel && !root) return

      const options = {
        root,
        threshold: 0.1,
      }

      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0]
        if (entry && entry.isIntersecting && !this.isLastData && !this.loadingTable) {
          this.getBusinessManagerDetailList()
        }
      }, options)

      this.observer.observe(sentinel)
    },
  },
}
</script>

<style scoped>
.bm-analytic-card {
    padding: 1.5rem 1rem;
    @apply border rounded-lg bg-white w-full flex flex-col gap-x-2 gap-y-4;
}

.bm-analytic-card-icon-container {
    @apply rounded-md flex justify-center items-center;
}

.bm-analytic-card > *:first-child {
  margin-bottom: .25rem
}

h1,
h2,
p {
  @apply m-0;
}

.btn-primary {
  border-radius: 10px !important;
}

::v-deep .vs__dropdown-option--highlight:not(.vs__dropdown-option--selected),
::v-deep .vs__dropdown-option:not(.vs__dropdown-option--selected):hover {
  background-color: #F3F4F6 !important;
  color: #333333 !important;
}

::v-deep .vs__dropdown-option--selected,
::v-deep .vs__dropdown-option--selected.vs__dropdown-option--highlight,
::v-deep .vs__dropdown-option--selected:hover {
  background-color: #F95031 !important;
  color: #FFFFFF !important;
}
</style>
